import {
  Badge,
  Col,
  Dropdown,
  Input,
  notification,
  Pagination,
  Popconfirm,
  Row,
  Spin,
} from "antd";
import React, { useEffect, useState } from "react";
import { MdPersonAdd, MdDelete, MdEdit } from "react-icons/md";
import { BiChevronDown, BiFilterAlt } from "react-icons/bi";
import { LoadingOutlined } from "@ant-design/icons";
import { IoIosSend } from "react-icons/io";
import { AiFillEye } from "react-icons/ai";
import { GetDropDownApi } from "../../../Services/CommonApis";
import { arrayToOptions } from "../../../Services/GeneralFunctions";
import { useOutletContext } from "react-router-dom";

const { Search } = Input;

export default function Mediclaim() {
  const { dropDowns } = useOutletContext();

  const [api, contextHolder] = notification.useNotification();

  const [ticketData, setTicketData] = useState(null);
  const [raiseTicketToggle, setRaiseTicketToggle] = useState(false);

  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(10);

  const [isActiveFilter, setIsActiveFilter] = useState("");
  const [employeeIdFilter, setEmployeeIdFilter] = useState("");
  const [employeeNameFilter, setEmployeeNameFilter] = useState("");

  const [tableLoader, setTableLoader] = useState(false);

  const getTicketData = async (isActive, id = "", name = "") => {
    // setTicketData(null);
    // try {
    //   setTableLoader(true);
    //   const data = await GetAllEmployeesApi(page, isActive, id, name);
    //   setTableLoader(false);
    //   if (data.data.success) {
    //     setTicketData(data.data.data.data);
    //     setTotal(data.data.data.page_count * 10);
    //   }
    //   else {
    //     api.error({
    //       message: 'Error while fetching Employees List',
    //       description: data.data.message,
    //       placement: 'top'
    //     })
    //   }
    // }
    // catch (err) {
    //   setTableLoader(false);
    //   api.error({
    //     message: err.message,
    //     description: 'Try to check your Internet Connection.',
    //     placement: 'top'
    //   })
    // }
  };

  const handleDelete = async (id, eCode) => {
    // try {
    //   const data = await DeleteEmployeeApi(id);
    //   if (data.data.success) {
    //     api.success({
    //       message: `Employee (${eCode}) deleted successfully.`,
    //       placement: 'top'
    //     });
    //   }
    //   else {
    //     api.error({
    //       message: `Error while Deleting Employee (${eCode})`,
    //       description: data.data.message,
    //       placement: 'top'
    //     });
    //   }
    //   console.log(data);
    // }
    // catch (err) {
    //   api.error({
    //     message: err.message,
    //     description: 'Try to check your Internet Connection.',
    //     placement: 'top'
    //   });
    // }
  };

  const onClick = ({ key }) => {
    console.log(key);
    setEmployeeIdFilter("");
    setEmployeeNameFilter("");
    setIsActiveFilter(key);
    if (page !== 1) {
      setPage(1);
    }
  };

  useEffect(() => {
    if (isActiveFilter !== null) {
      getTicketData(isActiveFilter);
    } else {
      getTicketData("", employeeIdFilter, employeeNameFilter);
    }
  }, [isActiveFilter, page]);

  const items = dropDowns?.TICKET_STATUS || [];

  return (
    <>
      {contextHolder}

      <section className="bg-white p-4 shadow-sm border border-gray-200 w-full rounded-2xl flex justify-between mb-2">
        <h2 className="text-2xl font-semibold text-gray-800">Mediclaim</h2>
      </section>
      <Row
        className="py-2 box-shadow responsive-row default-background-color mt-3"
        style={{ borderRadius: "10px" }}
      >
        <Col className="py-2 no-display">
          <span style={{ fontSize: "20px" }}>Employee Code:</span>
        </Col>
        <Col className="py-2 no-display">
          <span style={{ fontSize: "20px" }}>Employee Name:</span>
        </Col>
      </Row>

      {/* <Col style={{overflowX: 'auto'}}>
      <table className='custom-table'>
        <thead>
          <tr>
            <th>Ticket Number</th>
            <th>Raised On</th>
            <Dropdown 
              menu={{items, onClick}}
              trigger={['click']}
              
            >
            <th style={{cursor: 'pointer'}}>
                Status <BiFilterAlt /><BiChevronDown />
            </th>
            </Dropdown>
            <th>Updated On</th>
            <th>Assigned To</th>
            <th>Remark</th>
            <th>Remark by HR</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          { ticketData &&
            ticketData.map((val) => 
              <tr>
                <td>{val.name}</td>
                <td>{val.email}</td>
                <td>{val.employee_id}</td>
                <td>{val.biometric_id}</td>
                <td>{val.biometric_id}</td>
                <td>{val.manager.name}</td>
                <td>{val.is_active ? <Badge status="success" text="Yes" /> : <Badge status="error" text="No" />}</td>
                <td className='d-flex justify-content-center'>
                    <div className='action-button mx-2 bg-light bg-gradient'><AiFillEye className='text-dark fs-5' /></div>

                    <Popconfirm
                        title={`Are you sure to delete Ticket (Ticket ID)?`}
                        onConfirm={() => handleDelete(val._id, val.employee_id)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <div className='action-button mx-2 bg-danger bg-gradient'><MdDelete className='fs-5' /></div>
                    </Popconfirm>  
                </td>
              </tr>
            )
          }
          
        </tbody>
        <tfoot></tfoot>
      </table>
      { tableLoader && <Row className='justify-content-center py-3'>
        <Spin size='large' indicator={<LoadingOutlined className='text-light' />} spinning={true}/>
      </Row>}

      </Col> */}
      {total > 10 && (
        <div className="round-edges bg-light py-2 my-2 text-center">
          <Pagination
            current={page}
            onChange={(val) => setPage(val)}
            total={total}
            hideOnSinglePage
          />
        </div>
      )}
    </>
  );
}
